import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { DigestionTopicEditForm } from "./components/DigestionTopicEditForm";

export function EditDigestionTopicPage() {
  return (
    <Page title="Edit Digestion Topic">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <DigestionTopicEditForm />
      </Container>
    </Page>
  );
}
